import { render } from "./ContentTable.vue?vue&type=template&id=5dbd90ac&scoped=true"
import script from "./ContentTable.vue?vue&type=script&lang=js"
export * from "./ContentTable.vue?vue&type=script&lang=js"

import "./ContentTable.vue?vue&type=style&index=0&id=5dbd90ac&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbd90ac"]])

export default __exports__